import { Component, inject } from "@angular/core";
import { MatBottomSheetRef } from "@angular/material/bottom-sheet";
import { RouterLink, RouterLinkActive } from "@angular/router";
import { TranslatePipe } from "@ngx-translate/core";
import { SubMenu, SubMenuItem } from "@zeraki/zeraki-ui";
import { SchoolInfoService } from "src/app/core/services/school-info.service";
import { UserPermissionsService } from "src/app/core/services/user-permissions.service";
import { UserRoleService } from "src/app/core/services/user-role.service";
import { BottomMenuSheetItemComponent } from "../bottom-menu-sheet-item/bottom-menu-sheet-item.component";

@Component({
	selector: "app-bottom-menu-sheet",
	imports: [BottomMenuSheetItemComponent, RouterLink, RouterLinkActive, TranslatePipe, SubMenu, SubMenuItem],
	templateUrl: "./bottom-menu-sheet.component.html",
})
export class BottomMenuSheetComponent {
	private bottomSheet = inject(MatBottomSheetRef);
	private schoolInfoService = inject(SchoolInfoService);

	public userRole = inject(UserRoleService);
	public userPermissions = inject(UserPermissionsService);

	school = this.schoolInfoService.getSchool();

	close(): void {
		this.bottomSheet.dismiss();
	}
}
